import React, { useEffect, useRef, useState } from "react";
import {
  cobranzasAPI
} from "../../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../../utils/Tools";
import { toast } from "react-toastify";
import TarjetasBancoCuotasPedraza from "../../Global/TarjetasBancoCuotasPedraza";
import NumberFormat from "react-number-format";
import TotalConTarjeta from "../../Global/TotalConTarjeta";

const ModalLinkPago = (props) => {
  const myRefname = useRef(null);
  //const [habilitarBoton, setHabilitarBoton] = useState("ok");
  const { reserva, onCancelarClick } = props;
  const [mail, setMail] = useState("");
  const [urlLink, setUrlLink] = useState("");
  const [importe, setImporte] = useState(0);
  const [tarjetaElegida, setTarjetaElegida] = useState({});
  const [cuotaElegida, setCuotaElegida] = useState({ interes: 0 });
  const [bancoElegido, setBancoElegido] = useState({});

  //const tipoCliente = sessionStorage.getItem("tipoCliente");

  useEffect(() => {
    myRefname.current.click();
  }, []);

  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    //const success = copyToClipboard(urlLink);
    navigator.clipboard
      .writeText(urlLink)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.log("No se pudo copiar, inténtelo manualmente.");
      });

    /*
    if (success) {
      setIsCopied(true);

      // Reinicia el mensaje después de 2 segundos
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } else {
      // Si falla, podrías mostrar un mensaje de error o instruir al usuario a copiar manualmente.
      console.log("No se pudo copiar, inténtelo manualmente.");
    }
      */
  };

  const handleGenerarLinkDePagoClick = (e, conEnvioDeMail) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");

    if (!importe) {
      toast.info("Debe ingresar un importe.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (
      mail === "" ||
      !bancoElegido.id ||
      !tarjetaElegida.id ||
      !cuotaElegida.cantidad
    ) {
      toast.info("Debe comlpetar todos los campos de la tarjeta y email", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    const pagoElectronico = {
      canal: "WEB",
      totalPagar: importe,
      email: mail,
      tarjetaElegida,
      cuotaElegida,
      bancoElegido,
      reserva,
      conEnvioDeMail,
    };

    const data = JSON.stringify({
      peticion: "generarLinkDePago",
      token,
      pagoElectronico,
    });

    cobranzasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setUrlLink(respuesta.data);    
        if (conEnvioDeMail) {
          toast.success(respuesta.mensaje, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } else {
        setUrlLink(respuesta ? respuesta.mensaje : "Ha ocurrido un error");
      }
    });
  };

  const handleTarjetaClick = (tarjetaEleg, cuotaElegida) => {
    setTarjetaElegida(tarjetaEleg);
    setCuotaElegida(cuotaElegida);
  };

  const handleBancoClick = (banco) => {
    setBancoElegido(banco);
  };

  const handleCuotaClick = (cuotaEleg) => {
    setCuotaElegida(cuotaEleg);
  };

  const handlePagoChange = (e) => {
    if (e.target.value === "") return;
    const numberWithoutDot = e.target.value.replaceAll(",", "");
    setImporte(numberWithoutDot);
  };

  return (
    <div id="loader" className="loader result">
      <button
        ref={myRefname}
        type="button"
        style={{ display: "none" }}
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#exampleModalCenter"
      >
        Launch demo modal
      </button>

      <div
        className="modal fade bd-example-modal-lg"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Generar Link de Pago
              </h5>
              <button
                type="button"
                onClick={() => onCancelarClick()}
                style={{ color: "#fff", opacity: "1", textShadow: "none" }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <TarjetasBancoCuotasPedraza
                cuotaElegida={cuotaElegida}
                tarjetaElegida={tarjetaElegida}
                onTarjetaClick={handleTarjetaClick}
                onBancoClick={handleBancoClick}
                onCuotaClick={handleCuotaClick}
                producto={reserva.producto}
              />
              <div className="input-container col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12">
                <div
                  className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                  style={{ padding: "0", display: "inline-block" }}
                >
                  <label
                    style={{ marginTop: "5px" }}
                    className="labelPerfil text-left"
                  >
                    Email
                  </label>
                  <input
                    value={mail}
                    name="mail"
                    placeholder="Email"
                    type="text"
                    className="form-control"
                    onChange={(e) => setMail(e.target.value)}
                  />
                </div>
                <div
                  className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                  style={{ textAlign: "left", display: "inline-block" }}
                >
                  <label className="labelForm text-left">
                    Ingresar Importe (el "." es para decimales)
                  </label>
                  <NumberFormat
                    value={importe}
                    className="form-control"
                    name="importe"
                    displayType={"input"}
                    thousandSeparator=","
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    decimalSeparator="."
                    onChange={handlePagoChange}
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: "10px",
                  backgroundColor: "#181e34",
                  color: "#fff",
                }}
              >
                <TotalConTarjeta
                  cuotaElegida={cuotaElegida}
                  totalPaquete={
                    reserva.saldo * reserva.producto.moneda.cotizacion
                  }
                  impuestoPais="0"
                  importeAPagar={importe}
                  //importeProporcionalRGPais={importeProporcionalRGPais}
                />
              </div>
              <div style={{ marginTop: "10px" }}>
                <button
                  type="button"
                  onClick={() => onCancelarClick()}
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  style={{ margin: "0 10px" }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={(e) => handleGenerarLinkDePagoClick(e, false)}
                  className="btn btn-primary"
                >
                  Generar Link
                </button>
              </div>
              {urlLink !== "" && (
                <div>
                  <p className="labelForm text-left">¡Link generado! <br />
                    Podés copiarlo en el portapapeles o enviar un mail automaticamente</p>
                  
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleCopy}
                    style={{ margin: "0 10px" }}
                    disabled={urlLink === ""}
                  >
                    {isCopied ? "¡Copiado!" : "Copiar al Portapapeles"}
                  </button>
                  <button
                    type="button"
                    onClick={(e) => handleGenerarLinkDePagoClick(e, true)}
                    className="btn btn-primary"
                    disabled={urlLink === ""}
                  >
                    Enviar al mail ingresado
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLinkPago;



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ModalLinkPago.js